const scheduledServicesDraggableCard = {
  serialNumber: "Serial Number: ",
  place: "Place: ",
  expirationDate: "Expiration Date: ",
  service: "Service: ",
  company: "Company: "
};

export default scheduledServicesDraggableCard;
